import axios from "axios"
import qs from "qs"

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
})

service.interceptors.request.use(config => {
  config.headers["content-type"] = "application/x-www-form-urlencoded"
  config.data = qs.stringify(config.data)
  return config
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status != 1) {
      return Promise.reject(new Error(res.info) || "Error")
    } else {
      return Promise.resolve(res.info)
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
